import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { QRReader } from "./QRReades";
import { fichajeTotem } from "../../services/apis";
import { FichadaDialog } from "./FichadaDialog";
import { CircularProgress, Fab, Grid, Typography } from "@mui/material";
import CachedIcon from '@mui/icons-material/Cached';
import { RelojTotem } from "../../utils/componentes-utiles/RelojTotem";
import { CerrarSesion } from "../../utils/componentes-utiles/CerrarSesion";

export const TotemFichajeQr = ({ id }) => {

    const [qrValue, setQrValue] = useState(null);
    const [estado, setEstado] = useState("idle");
    const [data, setData] = useState(null);
    const [totemID, setTotemId] = useState(id);

    const obtenerFechaActual = () => {
        const now = new Date();

        // Fecha en formato España → DD/MM/YYYY
        const fecha = now.toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        // Hora local España
        const hora = now.toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });

        // Convertimos DD/MM/YYYY → YYYY-MM-DD
        const [dia, mes, anio] = fecha.split("/");

        return `${anio}-${mes}-${dia} ${hora}`;
    };


    const fichar = async (value) => {
        try {
            setEstado("loading");

            const fechaActual = obtenerFechaActual();

            const response = await fichajeTotem({
                fecha: fechaActual,
                cardCode: value,
                totemCode: totemID
            });

            if (!response.success) {
                setEstado("error");
                setData(null);
                return;
            }

            setEstado("success");
            setData(response);

        } catch (error) {
            setEstado("error");
            setData(null);
        }
    };

    useEffect(() => {
        if (qrValue) fichar(qrValue);
    }, [qrValue]);

    const resetFichaje = () => {
        setQrValue(null);
        setEstado("idle");
        setData(null);
    };

    return (
        <Dialog
            open={true}
            fullScreen
            PaperProps={{
                sx: {
                    background: "linear-gradient(to bottom, #000000, #000000ff)",
                    color: "#fff",
                    pb: 3
                }
            }}
        >
            <DialogContent>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant='subtitle1'>
                            ID totem:{totemID}
                        </Typography>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            xs={1}
                        >

                            <Fab
                                size="large"
                                color="primary"
                                onClick={() => window.location.reload()}
                                sx={{
                                    backgroundColor: "#1f1f1f",
                                    boxShadow: "0px 0px 10px #59CE8F4d",
                                    "&:hover": { backgroundColor: "#272727" }
                                }}
                            >
                                <CachedIcon
                                    sx={{
                                        color: "#59CE8Fff",
                                        fontSize: 35,
                                        "&:hover": { transform: "rotate(-360deg)" },
                                        transition: "transform 0.5s ease-in-out"
                                    }}
                                />
                            </Fab>


                            <CerrarSesion />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={7}
                    >

                        <Typography variant='h4'
                            style={{
                                textAlign: "center",
                                // fontSize: "33px",
                                // fontWeight: "300",
                                color: "#E8F9FD",
                                // marginBottom: "10px",
                                // letterSpacing: "1px"
                            }}
                        >
                            Escanea el código QR de tu<br /> tarjeta de empleado

                        </Typography>

                        {/* Cámara */}
                        <div
                            style={{
                                width: 350,
                                height: 350,
                                backgroundColor: "#111",
                                borderRadius: 20,
                                overflow: "hidden",
                                border: "4px solid #59CE8Fff",
                                boxShadow: "0 0 20px #59CE8F4d",
                            }}
                        >
                            <QRReader
                                key={estado}
                                setQrValue={setQrValue}
                                onScan={(value) => {
                                    if (value?.trim()) setQrValue(value);
                                }}
                            />
                        </div>

                        {/* Reloj */}
                        <div >
                            <RelojTotem />
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>

            {/* Loader */}
            {
                estado === "loading" && (
                    <Dialog open fullScreen PaperProps={{
                        sx: {
                            background: "#000c",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }
                    }}>
                        <CircularProgress size={120} sx={{ color: "#59CE8Fff" }} />
                    </Dialog>
                )
            }

            {
                estado !== "idle" && estado !== "loading" && (
                    <FichadaDialog onClose={resetFichaje} estado={estado} data={data} />
                )
            }
        </Dialog >
    );
};
